export const getAuth = () => ({
    token   : localStorage.getItem('origo_access_token') || '',
    orgId   : localStorage.getItem('origo_org_id')      || '',  // internal numeric
    jdOrgId : localStorage.getItem('jd_organization_id') || ''   // JD tenant id
  });
  export const clearAuth = () => localStorage.clear();